import { DummyCrudSearchPub } from '../../modules/core/models/dummy-crud-search-pub.model';

export const dummyCrudSearchPubMockData: DummyCrudSearchPub[] = [
  new DummyCrudSearchPub({
    id: '1',
    name: 'Φαρμακευτικό Προϊόν Ασπιρίνη',
    description:
      'Αναλγητικό και αντιφλεγμονώδες φάρμακο για τη θεραπεία του πόνου και του πυρετού',
    price: 12.5,
    fileUrl: '/files/aspirin-leaflet.pdf',
    fileName: 'aspirin_οδηγιες_χρησης.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2026-03-15'),
    isActive: true,
    dateCreated: new Date('2024-01-10'),
    dateModified: new Date('2024-11-01'),
  }),
  new DummyCrudSearchPub({
    id: '2',
    name: 'Ιατρική Εξέταση Αίματος',
    description:
      'Πλήρης αιματολογική εξέταση με βιοχημικούς δείκτες και λιπιδαιμικό προφίλ',
    price: 45.0,
    fileUrl: '/files/blood-test-results.pdf',
    fileName: 'εξεταση_αιματος_αποτελεσματα.pdf',
    isUrgent: true,
    statusName: 'Σε επεξεργασία',
    dateExpired: new Date('2025-12-31'),
    isActive: true,
    dateCreated: new Date('2024-02-15'),
    dateModified: new Date('2024-11-10'),
  }),
  new DummyCrudSearchPub({
    id: '3',
    name: 'Παιδιατρική Εξέταση',
    description:
      'Γενική παιδιατρική εξέταση για παιδιά ηλικίας 2-12 ετών με εμβολιασμούς',
    price: 35.0,
    fileUrl: '/files/pediatric-checkup.pdf',
    fileName: 'παιδιατρικη_εξεταση_φακελος.pdf',
    isUrgent: false,
    statusName: 'Ολοκληρωμένο',
    dateExpired: new Date('2025-06-20'),
    isActive: true,
    dateCreated: new Date('2024-03-05'),
    dateModified: new Date('2024-10-25'),
  }),
  new DummyCrudSearchPub({
    id: '4',
    name: 'Καρδιολογική Επισκόπηση',
    description:
      'Ηλεκτροκαρδιογράφημα και υπερηχοκαρδιογράφημα για έλεγχο καρδιακής λειτουργίας',
    price: 85.0,
    fileUrl: '/files/cardiology-report.pdf',
    fileName: 'καρδιολογικη_εκθεση_2024.pdf',
    isUrgent: true,
    statusName: 'Επείγον',
    dateExpired: new Date('2025-02-28'),
    isActive: true,
    dateCreated: new Date('2024-04-12'),
    dateModified: new Date('2024-11-08'),
  }),
  new DummyCrudSearchPub({
    id: '5',
    name: 'Ορθοπαιδική Θεραπεία',
    description:
      'Φυσικοθεραπεία και ασκήσεις αποκατάστασης για τραυματισμούς μυοσκελετικού',
    price: 28.0,
    fileUrl: '/files/orthopedic-therapy.pdf',
    fileName: 'ορθοπαιδικη_θεραπεια_προγραμμα.pdf',
    isUrgent: false,
    statusName: 'Σε εξέλιξη',
    dateExpired: new Date('2025-08-15'),
    isActive: true,
    dateCreated: new Date('2024-05-20'),
    dateModified: new Date('2024-11-05'),
  }),
  new DummyCrudSearchPub({
    id: '6',
    name: 'Δερματολογικός Έλεγχος',
    description:
      'Εξέταση δέρματος για μελανώματα και άλλες δερματικές παθήσεις',
    price: 55.0,
    fileUrl: '/files/dermatology-screening.pdf',
    fileName: 'δερματολογικος_ελεγχος_φωτο.pdf',
    isUrgent: false,
    statusName: 'Προγραμματισμένο',
    dateExpired: new Date('2025-12-10'),
    isActive: true,
    dateCreated: new Date('2024-06-08'),
    dateModified: new Date('2024-10-30'),
  }),
  new DummyCrudSearchPub({
    id: '7',
    name: 'Οφθαλμολογική Εξέταση',
    description:
      'Έλεγχος οπτικής οξύτητας και πίεσης οφθαλμού με διαγνωστικές εξετάσεις',
    price: 42.0,
    fileUrl: '/files/eye-examination.pdf',
    fileName: 'οφθαλμολογικη_εκθεση_2024.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2025-09-30'),
    isActive: true,
    dateCreated: new Date('2024-07-15'),
    dateModified: new Date('2024-11-02'),
  }),
  new DummyCrudSearchPub({
    id: '8',
    name: 'Νευρολογική Αξιολόγηση',
    description: 'Εξέταση νευρολογικών λειτουργιών και ηλεκτροεγκεφαλογράφημα',
    price: 95.0,
    fileUrl: '/files/neurological-assessment.pdf',
    fileName: 'νευρολογικη_αξιολογηση_ΗΕΓ.pdf',
    isUrgent: true,
    statusName: 'Επείγον',
    dateExpired: new Date('2025-04-18'),
    isActive: true,
    dateCreated: new Date('2024-08-22'),
    dateModified: new Date('2024-11-12'),
  }),
  new DummyCrudSearchPub({
    id: '9',
    name: 'Γυναικολογικός Έλεγχος',
    description:
      'Ετήσια γυναικολογική εξέταση με τεστ Παπανικολάου και υπερηχογράφημα',
    price: 65.0,
    fileUrl: '/files/gynecology-checkup.pdf',
    fileName: 'γυναικολογικη_εξεταση_παπ.pdf',
    isUrgent: false,
    statusName: 'Ολοκληρωμένο',
    dateExpired: new Date('2025-07-25'),
    isActive: true,
    dateCreated: new Date('2024-09-10'),
    dateModified: new Date('2024-10-28'),
  }),
  new DummyCrudSearchPub({
    id: '10',
    name: 'Ψυχιατρική Συνεδρία',
    description:
      'Ψυχολογική αξιολόγηση και συμβουλευτική για άγχος και κατάθλιψη',
    price: 70.0,
    fileUrl: '/files/psychiatric-session.pdf',
    fileName: 'ψυχιατρικη_συνεδρια_αξιολογηση.pdf',
    isUrgent: false,
    statusName: 'Σε εξέλιξη',
    dateExpired: new Date('2025-11-20'),
    isActive: true,
    dateCreated: new Date('2024-10-05'),
    dateModified: new Date('2024-11-07'),
  }),
  new DummyCrudSearchPub({
    id: '11',
    name: 'Αντιβιοτικό Αμοξικιλίνη',
    description: 'Αντιμικροβιακό φάρμακο για τη θεραπεία βακτηριακών λοιμώξεων',
    price: 18.75,
    fileUrl: '/files/amoxicillin-info.pdf',
    fileName: 'αμοξικιλινη_οδηγιες_δοσολογια.pdf',
    isUrgent: false,
    statusName: 'Διαθέσιμο',
    dateExpired: new Date('2026-01-15'),
    isActive: true,
    dateCreated: new Date('2024-02-28'),
    dateModified: new Date('2024-11-03'),
  }),
  new DummyCrudSearchPub({
    id: '12',
    name: 'Μαγνητική Τομογραφία Εγκεφάλου',
    description:
      'MRI εγκεφάλου για διαγνωστικό έλεγχο νευρολογικών συμπτωμάτων',
    price: 320.0,
    fileUrl: '/files/brain-mri-report.pdf',
    fileName: 'ΜΤ_εγκεφαλου_αναφορα_2024.pdf',
    isUrgent: true,
    statusName: 'Επείγον',
    dateExpired: new Date('2025-03-10'),
    isActive: true,
    dateCreated: new Date('2024-01-18'),
    dateModified: new Date('2024-11-09'),
  }),
  new DummyCrudSearchPub({
    id: '13',
    name: 'Αντιυπερτασικό Φάρμακο',
    description:
      'Θεραπεία για τη ρύθμιση της αρτηριακής πίεσης σε υπερτασικούς ασθενείς',
    price: 24.3,
    fileUrl: '/files/hypertension-medication.pdf',
    fileName: 'αντιυπερτασικο_δοσολογια_οδηγιες.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2025-12-05'),
    isActive: true,
    dateCreated: new Date('2024-03-12'),
    dateModified: new Date('2024-10-20'),
  }),
  new DummyCrudSearchPub({
    id: '14',
    name: 'Ενδοσκόπηση Στομάχου',
    description:
      'Γαστροσκόπηση για διάγνωση παθήσεων του ανώτερου πεπτικού συστήματος',
    price: 150.0,
    fileUrl: '/files/gastroscopy-results.pdf',
    fileName: 'γαστροσκοπηση_ευρηματα_βιοψια.pdf',
    isUrgent: false,
    statusName: 'Προγραμματισμένο',
    dateExpired: new Date('2025-05-22'),
    isActive: true,
    dateCreated: new Date('2024-04-30'),
    dateModified: new Date('2024-11-01'),
  }),
  new DummyCrudSearchPub({
    id: '15',
    name: 'Ακτινογραφία Θώρακος',
    description:
      'Απλή ακτινογραφία θωρακικού κλωβού για έλεγχο πνευμόνων και καρδιάς',
    price: 25.0,
    fileUrl: '/files/chest-xray.pdf',
    fileName: 'ακτινογραφια_θωρακα_αναφορα.pdf',
    isUrgent: false,
    statusName: 'Ολοκληρωμένο',
    dateExpired: new Date('2025-08-08'),
    isActive: true,
    dateCreated: new Date('2024-05-15'),
    dateModified: new Date('2024-10-25'),
  }),
  new DummyCrudSearchPub({
    id: '16',
    name: 'Αντιδιαβητικό Φάρμακο',
    description: 'Μετφορμίνη για τη διαχείριση του διαβήτη τύπου 2',
    price: 16.9,
    fileUrl: '/files/diabetes-medication.pdf',
    fileName: 'μετφορμινη_οδηγιες_διατροφη.pdf',
    isUrgent: false,
    statusName: 'Διαθέσιμο',
    dateExpired: new Date('2026-02-28'),
    isActive: true,
    dateCreated: new Date('2024-06-20'),
    dateModified: new Date('2024-11-04'),
  }),
  new DummyCrudSearchPub({
    id: '17',
    name: 'Υπερηχογράφημα Κοιλίας',
    description: 'Υπερηχογραφικός έλεγχος κοιλιακών οργάνων και ήπατος',
    price: 75.0,
    fileUrl: '/files/abdominal-ultrasound.pdf',
    fileName: 'υπερηχογραφημα_κοιλιας_ηπαρ.pdf',
    isUrgent: false,
    statusName: 'Σε επεξεργασία',
    dateExpired: new Date('2025-10-15'),
    isActive: true,
    dateCreated: new Date('2024-07-08'),
    dateModified: new Date('2024-11-06'),
  }),
  new DummyCrudSearchPub({
    id: '18',
    name: 'Ουρολογική Εξέταση',
    description:
      'Έλεγχος ουροποιητικού συστήματος και προστάτη σε άνδρες άνω των 50',
    price: 52.0,
    fileUrl: '/files/urology-checkup.pdf',
    fileName: 'ουρολογικη_εξεταση_προστατης.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2025-06-12'),
    isActive: true,
    dateCreated: new Date('2024-08-14'),
    dateModified: new Date('2024-10-30'),
  }),
  new DummyCrudSearchPub({
    id: '19',
    name: 'Αντικαταθλιπτικό Φάρμακο',
    description: 'Σεραλίνη για τη θεραπεία κατάθλιψης και διαταραχών άγχους',
    price: 32.5,
    fileUrl: '/files/antidepressant-guide.pdf',
    fileName: 'σεραλινη_παρενεργειες_οδηγιες.pdf',
    isUrgent: false,
    statusName: 'Υπό έγκριση',
    dateExpired: new Date('2025-11-30'),
    isActive: true,
    dateCreated: new Date('2024-09-25'),
    dateModified: new Date('2024-11-08'),
  }),
  new DummyCrudSearchPub({
    id: '20',
    name: 'Αξονική Τομογραφία Θώρακος',
    description: 'CT θώρακα με σκιαγραφικό για λεπτομερή εξέταση πνευμόνων',
    price: 180.0,
    fileUrl: '/files/chest-ct-scan.pdf',
    fileName: 'αξονικη_θωρακα_σκιαγραφικο.pdf',
    isUrgent: true,
    statusName: 'Επείγον',
    dateExpired: new Date('2025-04-05'),
    isActive: true,
    dateCreated: new Date('2024-10-12'),
    dateModified: new Date('2024-11-11'),
  }),
  new DummyCrudSearchPub({
    id: '21',
    name: 'Εργαστηριακές Εξετάσεις Ούρων',
    description: 'Πλήρης εξέταση ούρων με καλλιέργεια και αντιβιόγραμμα',
    price: 35.0,
    fileUrl: '/files/urine-analysis.pdf',
    fileName: 'εξεταση_ουρων_καλλιεργεια.pdf',
    isUrgent: false,
    statusName: 'Ολοκληρωμένο',
    dateExpired: new Date('2025-07-18'),
    isActive: true,
    dateCreated: new Date('2024-02-05'),
    dateModified: new Date('2024-10-22'),
  }),
  new DummyCrudSearchPub({
    id: '22',
    name: 'Αναισθητικό Προϊόν',
    description:
      'Λιδοκαΐνη για τοπική αναισθησία σε μικρές χειρουργικές επεμβάσεις',
    price: 8.25,
    fileUrl: '/files/lidocaine-instructions.pdf',
    fileName: 'λιδοκαινη_τοπικη_αναισθησια.pdf',
    isUrgent: false,
    statusName: 'Διαθέσιμο',
    dateExpired: new Date('2025-09-20'),
    isActive: true,
    dateCreated: new Date('2024-03-18'),
    dateModified: new Date('2024-11-02'),
  }),
  new DummyCrudSearchPub({
    id: '23',
    name: 'Ενδοκρινολογική Εξέταση',
    description:
      'Έλεγχος θυρεοειδούς και ορμονικού προφίλ για διαταραχές μεταβολισμού',
    price: 88.0,
    fileUrl: '/files/endocrinology-tests.pdf',
    fileName: 'ενδοκρινολογικες_εξετασεις_TSH.pdf',
    isUrgent: false,
    statusName: 'Σε εξέλιξη',
    dateExpired: new Date('2025-12-22'),
    isActive: true,
    dateCreated: new Date('2024-04-25'),
    dateModified: new Date('2024-11-05'),
  }),
  new DummyCrudSearchPub({
    id: '24',
    name: 'Βιταμίνη D Συμπλήρωμα',
    description:
      'Συμπλήρωμα βιταμίνης D3 για την υγεία των οστών και του ανοσοποιητικού',
    price: 14.8,
    fileUrl: '/files/vitamin-d-supplement.pdf',
    fileName: 'βιταμινη_D3_δοσολογια_οφελη.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2026-06-10'),
    isActive: true,
    dateCreated: new Date('2024-05-30'),
    dateModified: new Date('2024-10-18'),
  }),
  new DummyCrudSearchPub({
    id: '25',
    name: 'Μαστογραφία',
    description: 'Ακτινολογική εξέταση μαστού για προληπτικό έλεγχο καρκίνου',
    price: 65.0,
    fileUrl: '/files/mammography-report.pdf',
    fileName: 'μαστογραφια_προληπτικος_ελεγχος.pdf',
    isUrgent: false,
    statusName: 'Προγραμματισμένο',
    dateExpired: new Date('2025-05-08'),
    isActive: true,
    dateCreated: new Date('2024-06-15'),
    dateModified: new Date('2024-11-01'),
  }),
  new DummyCrudSearchPub({
    id: '26',
    name: 'Φυσικοθεραπεία Σπονδυλικής',
    description:
      'Θεραπευτικές ασκήσεις και μασάζ για πόνο στη σπονδυλική στήλη',
    price: 38.0,
    fileUrl: '/files/spine-physiotherapy.pdf',
    fileName: 'φυσικοθεραπεια_σπονδυλικης_ασκησεις.pdf',
    isUrgent: false,
    statusName: 'Σε εξέλιξη',
    dateExpired: new Date('2025-08-28'),
    isActive: true,
    dateCreated: new Date('2024-07-22'),
    dateModified: new Date('2024-11-03'),
  }),
  new DummyCrudSearchPub({
    id: '27',
    name: 'Ψυχολογική Θεραπεία Παιδιών',
    description:
      'Παιδοψυχολογική υποστήριξη για παιδιά με μαθησιακές δυσκολίες',
    price: 55.0,
    fileUrl: '/files/child-psychology.pdf',
    fileName: 'παιδοψυχολογια_μαθησιακες_δυσκολιες.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2025-10-05'),
    isActive: true,
    dateCreated: new Date('2024-08-05'),
    dateModified: new Date('2024-11-07'),
  }),
  new DummyCrudSearchPub({
    id: '28',
    name: 'Αντιιστολογικό Φάρμακο',
    description: 'Αντιαλλεργικό φάρμακο για τη θεραπεία εποχικών αλλεργιών',
    price: 11.75,
    fileUrl: '/files/antihistamine-guide.pdf',
    fileName: 'αντιιστολογικο_εποχικες_αλλεργιες.pdf',
    isUrgent: false,
    statusName: 'Διαθέσιμο',
    dateExpired: new Date('2025-04-30'),
    isActive: true,
    dateCreated: new Date('2024-09-12'),
    dateModified: new Date('2024-10-28'),
  }),
  new DummyCrudSearchPub({
    id: '29',
    name: 'Κολονοσκόπηση',
    description:
      'Ενδοσκοπική εξέταση παχέος εντέρου για προληπτικό έλεγχο καρκίνου',
    price: 200.0,
    fileUrl: '/files/colonoscopy-report.pdf',
    fileName: 'κολονοσκοπηση_προληπτικος_ελεγχος.pdf',
    isUrgent: false,
    statusName: 'Υπό έγκριση',
    dateExpired: new Date('2025-03-25'),
    isActive: true,
    dateCreated: new Date('2024-10-18'),
    dateModified: new Date('2024-11-10'),
  }),
  new DummyCrudSearchPub({
    id: '30',
    name: 'Ομοιοπαθητικό Προϊόν',
    description:
      'Φυσικό συμπλήρωμα για την ενίσχυση του ανοσοποιητικού συστήματος',
    price: 22.9,
    fileUrl: '/files/homeopathic-supplement.pdf',
    fileName: 'ομοιοπαθητικο_ανοσοποιητικο_φυσικο.pdf',
    isUrgent: false,
    statusName: 'Ενεργό',
    dateExpired: new Date('2025-11-15'),
    isActive: true,
    dateCreated: new Date('2024-01-28'),
    dateModified: new Date('2024-11-04'),
  }),
];
